// Persist before sending; an interrupted request is always retried with this exact body.
export function readOperation<T extends { operationId: string }>(storage: Storage, key: string): T | null {
  const raw = storage.getItem(key);
  if (!raw) return null;
  const value = JSON.parse(raw) as T;
  if (!value || !/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(value.operationId))
    throw new Error("Не удалось прочитать сохранённую операцию. Обратитесь к администратору; новый запрос заблокирован.");
  return value;
}

export function saveOperation<T extends { operationId: string }>(storage: Storage, key: string, value: T): T {
  const previous = readOperation<T>(storage, key);
  if (previous) return previous;
  storage.setItem(key, JSON.stringify(value));
  return value;
}
